import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchInvoice: (uuid: string): NetworkPayload => ({
    url: `invoices/${uuid}/`,
    options: {
      method: "GET",
    },
  }),
};
